export const stundenBewertung = {
  fest: 'fest',
  dynamisch: 'dynamisch',
} as const;

export type StundenBewertung = keyof typeof stundenBewertung;
